// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../src/assets/font-icon/iconfont.css'
import '@/assets/iconfont/iconfont.css';
require('es6-promise/auto')
import animated from 'animate.css'
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAxios from 'vue-axios'
axios.defaults.withCredentials = true;
import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.use(animated)
Vue.use(VueAxios, axios)
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'OPfwfWopYoyhvGv50ST0DULf3tzvNXY1'
})
Vue.config.productionTip = false
Vue.prototype.$host = window.location.origin;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js